import { useAdvancedApprovalState } from 'app/domains/approval';
import { useActiveDocument } from 'shared/domains/documents';
import { Context } from './Context';
import { useStreamApprovalCheck } from './useStreamApprovalCheck';
export function ApprovalCheckProvider(props) {
    const { children } = props;
    const { id: documentId } = useActiveDocument();
    const { latestWorkflowId, setDocumentState, resetDocumentState } = useAdvancedApprovalState(documentId);
    const { startApprovalCheck, resetApprovalCheck, state, response, error } = useStreamApprovalCheck();
    const startCheck = (workflowId) => {
        setDocumentState({ latestWorkflowId: workflowId });
        startApprovalCheck(workflowId);
    };
    const rerunCheck = (context) => {
        if (latestWorkflowId) {
            startApprovalCheck(latestWorkflowId, context);
        }
    };
    const resetCheck = () => {
        resetApprovalCheck();
        resetDocumentState();
    };
    const value = {
        state,
        error,
        response,
        startCheck,
        rerunCheck,
        resetCheck,
    };
    return <Context.Provider value={value}>{children}</Context.Provider>;
}
